import { observable, computed, makeObservable, runInAction } from 'mobx'
import { parseShape, wrapPromise } from './utils';
import { GET_CLOSEST_EVENT, GET_OPEN_EVENTS } from 'api/graphql/events';
import Model from './index';

class EventsStore {

    events = [];
    loading = false;

    constructor(model) {
        this.model = model;
        makeObservable(this, {
            model: false,
            loading: observable,
            events: observable,
            closestEvent: computed
        })
    }

    setEvents(events) {
        this.events = events;
    }

    setLoadedEvents = ({events}) => {
        runInAction(() => {
            this.setEvents(events);
            this.model.specialist.specialists.forEach(spec => {
                const specEvents = events.filter(json => json.specialist.id === spec.id);
                if (specEvents.length > 0) {
                    spec.openEvents = specEvents;
                }
            })
        })
    }

    getEventsBySpec = (specId) => {
        return this.events.filter((event) => event.specialist.id === specId);
    }

    _findClosestEvent(events) {
        let min = events[0];
        let minTimestamp = new Date(min).getTime();
        for (const event of events) {
            if (new Date(event).getTime() < minTimestamp) {
                min = event;
                minTimestamp = new Date(min).getTime();
            }
        }
        return min;
    }

    get closestEvent() {
        if (this.events.length <= 0) {
            return null;
        }
        return this._findClosestEvent(this.events);
    }

}

export default EventsStore;
